export const FALLBACK_FOCUS_BUTTON = "fallback-focus-button";
export const MAX_NEXT_DAYS_COUNT = 7;
